<template>
  <div>
    <portal to="nav-bar">
      <nav-back-to-list />
    </portal>
    <async-component :asyncFunction="loadDetails" :params="apiParams" #default="{ loading, error }">
      <indeterminate-Line v-if="loading" class="mh2-l"/>
      <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
      <div v-else>
        <cross-entities-links entityCode='procedure' :entityId="id"/>
        <div class="entity-card">
          <div class="header-layout mh3 mh4-l mv3 relative">
            <div class="lh-copy">
              <h2 class="f5 f3-l ttu ma0 pa0 fw3 text-primary">
                <span>Процедура</span>
                <span class="ml3" title="Идентификатор процедуры"><span class="text-secondary">id</span> {{ procedure.id }}</span>
              </h2>
              <div class="">
                <a class="f6 link text-secondary underline" :href="procedureLink" target="_blank">
                  Открыть в ТендерПро
                </a>
              </div>
              <div class="mt3 text-secondary ttl fw4">
                {{ bidDirectionByCode(procedure.type).name }}
              </div>
              <h1 class="ma0 pa0 f6 f5-l mt1">
                <span class="text-primary db b ttu">{{ procedure.title }}</span>
              </h1>
              <div>{{ procedure.managerName }}</div>
            </div>
            <div class="pv2">
              <h2 class="f5 ttu ma0 pa0 fw3 text-accent">
                <span class="text-line-2">
                  {{ statuses[procedure.stateId].name }}
                </span>
              </h2>
            </div>
          </div>

          <entity-menu :items="menu" v-model="menuSelected"/>
          <keep-alive>
            <component :is="menu[menuSelected].component" class="bg-white"
              :proc='procedure'
              :journal='journal'
              :invites='invites'
              :winners='winners'
              :participants='participants'
              :stages='stages'
            />
          </keep-alive>
        </div>
      </div>
    </async-component>
  </div>
</template>

<script>
import NavBackToList from '@/components/common/NavBackToList.vue'
import AsyncComponent from '@/components/AsyncComponent.vue'
import IndeterminateLine from '@/components/ui/progress/IndeterminateLine.vue'
import CrossEntitiesLinks from '@/components/common/CrossEntitiesLinks.vue'
import EntityMenu from '@/components/common/EntityMenu.vue'
import CardDetails from '@/components/procedures/CardDetails.vue'
import CardJournal from '@/components/procedures/CardJournal.vue'
import CardInvites from '@/components/procedures/CardInvites.vue'
import { DataService } from '@/services/DataService.js'
import { mapGetters } from 'vuex'
import { tproURL } from '@/utils/app.js'

export default {
  components: {
    NavBackToList,
    AsyncComponent,
    IndeterminateLine,
    CrossEntitiesLinks,
    EntityMenu,
    CardDetails,
    CardJournal,
    CardInvites
  },
  props: ['id'],
  data () {
    return {
      menu: [{
        index: 0, name: 'ОСНОВНОЕ', component: 'CardDetails'
      }, {
        index: 1, name: 'ПРИГЛАШЕНИЯ', component: 'CardInvites'
      }, {
        index: 2, name: 'Журнал', component: 'CardJournal'
      }],
      menuSelected: 0,
      procedure: {},
      journal: [],
      invites: [],
      winners: [],
      offers: [],
      externalOffers: [],
      stages: []
    }
  },
  computed: {
    ...mapGetters('procedure', ['bidDirectionByCode', 'statuses']),
    apiParams () {
      return {
        procId: this.id
      }
    },
    participants () {
      const registered = [...this.offers].map(o => ({ title: o.title, companyId: o.companyId, externalSupplier: false }))
      const external = [...this.externalOffers].map(o => ({ title: o.title, externalSupplier: true }))
      return [...registered, ...external]
    },
    procedureLink () {
      const procId = this.procedure.id
      const mode = this.procedure.type.toLowerCase()
      const sid = this.$store.getters['session/user'].sid
      return `${tproURL()}/edit_tender.shtml?tenderid=${procId}&mode=${mode}&hold=0&sid=${sid}`
    }
  },
  methods: {
    loadDetails (params) {
      return Promise.all([
        DataService.getProcedureDetails(params),
        DataService.getProcedureJournal({
          procedureId: params.procId,
          types: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 21, 22, 31, 32, 33, 34, 35, 36, 37, 106, 107, 108, 109, 110, 111, 130, 131, 138, 141, 181, 182, 183, 189, 200, 201, 400, 401, 402, 501, 555, 556, 557, 558, 559]
        }),
        DataService.getProcedureInvites({ procedureId: params.procId }),
        DataService.getProcedureWinners({ procedureId: params.procId }),
        DataService.getProcedureOffers({ procedureId: params.procId }),
        DataService.getProcedureExternalOffers({ procedureId: params.procId }),
        DataService.getProcedureStages({ procedureId: +params.procId })
      ]).then(([
        { data: { procedure }, errors: pErrors },
        { data: { procedureJournal }, errors: jErrors },
        { data: { procedureInvites }, errors: iErrors },
        { data: { procedureWinners }, errors: wErrors },
        { data: { procedureOffers }, errors: oErrors },
        { data: { procedureExternalOffers }, errors: eoErrors },
        { data: { procedureStages }, errors: sErrors }
      ]) => {
        if (jErrors || pErrors || iErrors || wErrors /* || sErrors */ /* oErrors || eoErrors */) {
          return {
            errors: [
              jErrors || [],
              pErrors || [],
              iErrors || [],
              wErrors || []//,
              // sErrors || [], TODO: временный хак
              // oErrors || [], TODO: временный хак
              // eoErrors || []
            ].flat()
          }
        } else {
          this.journal = procedureJournal
          this.procedure = procedure
          this.invites = procedureInvites
          this.winners = procedureWinners
          // TODO: временный хак
          // Для процедур на стадиях согласование и открыт метод получения офферов возвращает ошибку
          // надо завести баг на основную систему чтобы он возвращал или пустой список или офферы
          // а пока в случае ошибки считаем что нет офферов...
          this.offers = oErrors
            ? []
            : this.$lo.uniqBy(procedureOffers, 'companyId')
          this.externalOffers = eoErrors
            ? []
            : this.$lo.uniqBy(procedureExternalOffers, 'title')
          // TODO: временный хак
          // Для процедур на стадиях формирование и открыт метод получения этапов конкурса возвращает ошибку
          // надо завести баг на основную систему чтобы он возвращал этапы
          // а пока в случае ошибки считаем что нет этапов...
          this.stages = sErrors
            ? []
            : procedureStages
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-layout {
  display: flex;
  flex-direction: column-reverse;
}
@media screen and (min-width: 60em) {
  .header-layout {
    display: grid;
    grid-template-columns: 2.5fr 1fr;
    grid-template-rows: auto;
    column-gap: 1rem;
    row-gap: 3rem;
  }
}
.header-section {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
}
.header-section-right {
  justify-content: left;
}
.header-delimeter {
  border-top-style: solid;
  border-top-width: .25rem;
  border-color: #BCCCDC;
}
.details-layout {
  overflow: hidden;
}
</style>
